"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLoanTapeEvaluator = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
const intermediateCalcEvaluator_1 = require("./intermediateCalcEvaluator");
const progressHelper_1 = require("./progressHelper");
const createPostProcessedFields = ({ requiredIntermediateFields, orgSlugMap, loanTapeType, creditFacilityId, signaledExternalAssignment, baseFields, }) => {
    const { originalOwnerSlug } = requiredIntermediateFields;
    const organization = orgSlugMap[originalOwnerSlug];
    (0, common_1.finleyAssert)(organization, `organization must exist:[${originalOwnerSlug}]`);
    let preassignmentCreditFacilityId = null;
    switch (loanTapeType) {
        case 'masterLoanTape':
            // masterLoanTapeType is always null
            break;
        case 'preassignedLoanTape':
            preassignmentCreditFacilityId = creditFacilityId;
            break;
        case 'preassignedMasterLoanTape': {
            (0, common_1.finleyAssert)(signaledExternalAssignment, `signaledExternalAssignment configuration must exist for preassignedMasterLoanTape [creditFacilityId:${creditFacilityId}]`);
            const { signaledExternalAssignmentField, signaledExternalAssignment: signaledExternalAssignmentMatch, } = signaledExternalAssignment;
            const value = baseFields[signaledExternalAssignmentField];
            (0, common_1.finleyAssert)(!_.isNil(value), `signaledExternalAssignment must defined in preassignedMasterLoanTape for [creditFacilityId:${creditFacilityId}]`);
            if (String(value).match(signaledExternalAssignmentMatch)) {
                preassignmentCreditFacilityId = creditFacilityId;
            }
            break;
        }
        default:
            (0, common_1.finleyAssertUnreachable)(loanTapeType);
    }
    const postProcessedFields = {
        originalOwnerId: organization.id,
        normalizedExposure: Math.max(0, requiredIntermediateFields.exposure),
        preassignmentCreditFacilityId,
        performingExposure: requiredIntermediateFields.normalizedisChargedOff ||
            requiredIntermediateFields.normalizedisDelinquent
            ? 0
            : requiredIntermediateFields.exposure,
    };
    return postProcessedFields;
};
const createLoanTapeEvaluator = async ({ config, loanTapeType, creditFacilityId, orgSlugMap, loanTapeMetadataExtractor, f1EngineMode, }) => {
    const externalReceivableIdField = config._config_.externalReceivableIdField;
    const { baseFieldConfigs, signaledExternalAssignment } = config._config_;
    const { loanProductId } = config;
    const loanTapeMetadata = await loanTapeMetadataExtractor();
    const intermediateCalcEvaluator = (0, intermediateCalcEvaluator_1.createIntermediateCalcEvaluator)(config._config_.intermediateCalcConfigs, f1EngineMode);
    const evaluateIntermediate = ({ baseFields, externalReceivableId, }) => {
        // intermediate calc evaluation
        const { requiredIntermediateFields, dynamicIntermediateFields, } = intermediateCalcEvaluator.evaluate({
            baseFields,
            loanTapeMetadata,
            externalReceivableId,
        });
        // postProcessedFields
        const postProcessedFields = createPostProcessedFields({
            requiredIntermediateFields,
            orgSlugMap,
            baseFields,
            loanTapeType,
            creditFacilityId,
            signaledExternalAssignment,
        });
        // return everything.
        return {
            requiredIntermediateFields,
            dynamicIntermediateFields,
            postProcessedFields,
        };
    };
    const sanitizedRowToBaseFields = ({ sanitizedRow, }) => {
        const baseFields = sanitizedRow;
        const externalReceivableId = sanitizedRow[externalReceivableIdField];
        (0, common_1.finleyAssert)(externalReceivableId !== null && externalReceivableId !== undefined, `Could not find externalReceivableId [${externalReceivableIdField}] for CSV row`);
        return {
            baseFields,
            externalReceivableId: String(externalReceivableId),
        };
    };
    const convertToCreditFacilityReceivables = async ({ csv, progressCallback, assignmentFilter, csvParser, }) => {
        const sanitizedResults = await (0, tape_sanitizer_1.sanitizeTape)({
            csv,
            baseFieldConfig: baseFieldConfigs,
            externalReferenceIdField: externalReceivableIdField,
            assignmentFilter,
            csvParser,
        });
        if (!sanitizedResults.isValid) {
            return {
                errors: (0, tape_sanitizer_1.consolidateToStructuredErrors)(sanitizedResults.errors),
                creditFacilityReceivableWithoutFinleyId: [],
            };
        }
        const limitedTape = sanitizedResults.data;
        // we will report progress at every 4 seconds or after every 10% of rows - whichever happens first.
        const numRows = limitedTape.length;
        const { updateProgress } = (0, progressHelper_1.createProgressHelper)({
            progressCallback,
            operation: 'Convert to credit facility receivables',
            numRows,
        });
        const creditFacilityReceivableWithoutFinleyId = [];
        // eslint-disable-next-line no-restricted-syntax, no-plusplus
        for (let index = 0; index < limitedTape.length; index++) {
            const sanitizedRow = limitedTape[index];
            // eslint-disable-next-line no-await-in-loop
            await updateProgress(index);
            //  run base fields and intermediate calcs.
            const { baseFields, externalReceivableId } = sanitizedRowToBaseFields({
                sanitizedRow,
            });
            //  run intermediate calcs.
            const { requiredIntermediateFields, dynamicIntermediateFields, postProcessedFields, } = evaluateIntermediate({
                baseFields,
                externalReceivableId,
            });
            creditFacilityReceivableWithoutFinleyId.push({
                sanitizedRow,
                loanProductId,
                externalReceivableId,
                baseFields,
                dynamicIntermediateFields,
                requiredIntermediateFields,
                postProcessedFields,
            });
        }
        return {
            creditFacilityReceivableWithoutFinleyId,
            errors: [],
        };
    };
    return {
        evaluateIntermediate,
        convertToCreditFacilityReceivables,
    };
};
exports.createLoanTapeEvaluator = createLoanTapeEvaluator;
//# sourceMappingURL=loanTapeEvaluator.js.map